import { Box, Stack, Button, Typography, IconButton, Card, CardContent } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslate, useCustom } from "@refinedev/core";
import { Delete as DeleteIcon } from "@mui/icons-material";
import RHFAutocompleteString from './RHFAutocompleteString';
import React, { useState } from 'react';
import DiscountForm from "./Discount";
import { IDealForm } from '@/utils/zod/dealFormValidation';
import { DiscountStringField } from "./DiscountStringField";
import { CostPriceUpchargeField } from "./CostPriceUpchargeField";
import { defaultRule } from "@/utils/helpers/ruleHelper";

export const DealRuleForm = React.memo(({
    name = "tag_rules",
}: {
    name: "tag_rules";
}) => {
    const t = useTranslate();
    const { control } = useFormContext<IDealForm>();

    const { data: tags } = useCustom<string[]>({
        url: "/companies/company-categories",
        method: "get",
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name,
    });

    const [activeRuleIndex, setActiveRuleIndex] = useState<number | null>(null);

    const handleAddRule = () => {
        append(defaultRule);
    };

    return (
        <Box>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <Box component="h3">{t("products.fields.rules")}</Box>
                <Button
                    variant="text"
                    sx={{ fontWeight: 500, '&:hover': { fontWeight: 600 } }}
                    onClick={handleAddRule}
                >
                    +{t("products.buttons.addRule")}
                </Button>
            </Stack>
            {fields.map((field, index) => {
                return (
                    <Card key={field.id} variant="outlined" sx={{ mb: 2 }}>
                        <CardContent>
                            <Stack spacing={2}>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    alignItems="center"
                                    justifyContent="flex-start"
                                    mb={1}
                                >
                                    <Typography variant="subtitle1">
                                        Rule {index + 1}:
                                    </Typography>
                                    {/* <VisibilityToggleForm
                                        name={`${name}[${index}].visibility`}
                                    /> */}
                                </Stack>
                                <Stack direction="row" spacing={2} alignItems="center" mb={1}>
                                    <Box sx={{ width: "300px" }}>
                                        <RHFAutocompleteString
                                            name={`${name}[${index}].company_category`}
                                            label={t("company.fields.company-category")}
                                            options={tags?.data || []}
                                            multiple={false}
                                            createNew={false}
                                            required
                                            size="small"
                                        />
                                    </Box>
                                    <Box sx={{ width: "250px" }}>                                        
                                        <CostPriceUpchargeField
                                            name={`${name}[${index}].cost_price_upcharge_percentage`}
                                        />
                                    </Box>
                                    <DiscountStringField
                                        name={`${name}[${index}].discount.discount_string`}
                                        onEditClick={() => setActiveRuleIndex(index)}
                                        index={index}
                                        label={t("discount.actions.create")}
                                    />
                                    <IconButton
                                        color="error"
                                        onClick={() => remove(index)}
                                        sx={{
                                            height: "54px",
                                            width: "54px"
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>
                );
            })}

            {activeRuleIndex !== null && (
                <DiscountForm
                    name={`${name}.${activeRuleIndex}.discount`}
                    open={activeRuleIndex !== null}
                    onClose={() => setActiveRuleIndex(null)}
                    discountType={"product_creation_based"}
                />
            )}
        </Box>
    );
});